import { TemplateSupport } from "./types/template";
export const TEMPLATE_CHANNELS = [
    { support: TemplateSupport.Email, labelKey: "templating.support.email", theme: "yellow", icon: "ri-mail-line", enabled: true },
    { support: TemplateSupport.Form, labelKey: "templating.support.form", theme: "indigo", icon: "ri-file-list-3-line", enabled: false },
    { support: TemplateSupport.LandingPage, labelKey: "templating.support.landingPage", theme: "violet", icon: "ri-layout-4-line", enabled: false },
    { support: TemplateSupport.Sms, labelKey: "templating.support.sms", theme: "cyan", icon: "ri-message-2-line", enabled: false },
    { support: TemplateSupport.WhatsApp, labelKey: "templating.support.whatsApp", theme: "green", icon: "ri-whatsapp-line", enabled: false },
    { support: TemplateSupport.Notification, labelKey: "templating.support.notification", theme: "orange", icon: "ri-notification-3-line", enabled: false },
];
export const DEFAULT_TEMPLATE_SUPPORT = TemplateSupport.Email;
export function enabledTemplateChannels() {
    return TEMPLATE_CHANNELS.filter((channel) => channel.enabled);
}
export function findTemplateChannel(support) {
    return TEMPLATE_CHANNELS.find((channel) => channel.support === support);
}
export function isTemplateChannelEnabled(support) {
    return findTemplateChannel(support)?.enabled === true;
}
